import React, { useEffect, useState, useRef } from 'react';
import { get, isEmpty } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import {
  examHallRequest,
  examHallPlayerRequest
} from '../../../actions/examHallActions';
import { openSnackBar } from '../../../actions/snackbarAction';
// Global Components
import { dateFormat } from '../../../api/dateFormat';
import NoData from '../../../components/NoData';
import TimerCard from '../../../components/TimerCard';
import LoadingSkeleton from '../../../components/LoadingSkeleton';
import PopUpModal from '../../../components/PopUpModal';
// Components
import ExamHallAttempt from './ExamHallAttempt';
// Styles
import './styles.scss';
import { Grid } from '@material-ui/core';
import PageHeading from '../../../components/PageHeading';
import AttemptedExamTable from './components/attemptedExamTable';

const useStyles = makeStyles(theme => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%'
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%'
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '65%'
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '65%'
    }
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px'
  }
}));

export default function ExamHall() {
  const classes = useStyles();
  const childRef = useRef();
  // State
  const [isFetching, setIsFetching] = useState(false);

  // Reducers
  const dispatch = useDispatch();
  const jwt = useSelector(state => get(state, 'loginReducer.data.jwt', {}));
  const profile = useSelector(state =>
    get(state, 'loginReducer.data.profile', '')
  );
  const errorMessage = useSelector(state =>
    get(state, 'examHallReducer.errorMessage', '')
  );
  const digitalLiveClassListData = useSelector(state =>
    get(state, 'examHallReducer.data.listSchedule', [])
  );
  const examDetails = useSelector(state =>
    get(state, 'examHallReducer.livePlayerData', {})
  );
  const rows = useSelector(state =>
    get(state, 'examHallReducer.data.listAttemptHistory', [])
  );

  //   Functions
  useEffect(() => {
    setIsFetching(true);
    examHallRequest(jwt, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const onRefresh = React.useCallback(() => {
    setIsFetching(true);
    examHallRequest(jwt, dispatch).then(() => {
      populateExamHallList();
      setIsFetching(false);
    });
  });

  const conv2Arr = () => {
    let result = [];
    let unique = [...new Set(digitalLiveClassListData.map(a => a.TestDate))];
    unique.map((data, i) => {
      result.push({
        TestDate: unique[i],
        listClass: digitalLiveClassListData.filter(date => {
          return date.TestDate.includes(unique[i]);
        })
      });
    });

    return result;
  };
  // Functions
  const populateExamHallList = () => {
    const newClassArray = conv2Arr();
    const list = [];
    (profile.EmpCode ? newClassArray : digitalLiveClassListData).map(
      (data, index) => {
        let classList = [];
        data.listExam.map((classData, classIndex) => {
          let uniqueCode = `${index}${classIndex}`;
          if (!(classData.Expiry < 0))
            return classList.push(
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={classData.RemainingTime}
                className="flex"
              >
                <TimerCard
                  key={uniqueCode}
                  subject={`${classData.PaperDuration} min`}
                  dateTime={`${classData.StartTime}`}
                  topic={classData.TestTitle}
                  callback={onRefresh}
                  handler={() => {
                    if (classData.RemainingTime < 0) {
                      fetchLiveURL(classData.PaperCode, classData.TestCode);
                    } else {
                      dispatch(
                        openSnackBar({
                          message: 'This exam is yet to start, please wait',
                          severity: 'warning'
                        })
                      );
                    }
                  }}
                  start={classData.RemainingTime < 0 ? 'EXPIRE IN' : 'START IN'}
                  initialTime={
                    classData.RemainingTime < 0
                      ? classData.Expiry * 1000
                      : classData.RemainingTime * 1000
                  }
                />
              </Grid>
            );
        });
        return list.push(
          <div className="class-wrapper" key={index}>
            <div className="date-heading">
              {profile.EmpCode
                ? dateFormat(data.TestDate)
                : `${data.TestDay}, ${dateFormat(data.TestDate)}`}
            </div>
            <Grid container spacing={2} key={index}>
              {classList}
            </Grid>
          </div>
        );
      }
    );
    return list;
  };

  const fetchLiveURL = async (PaperCode, TestCode) => {
    try {
      examHallPlayerRequest(jwt, PaperCode, TestCode, dispatch).then(() => {
        childRef.current.handleClickOpen();
        populateExamHallList();
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <PageHeading titlePrimary="Digital " titleSecondary="Examination Hall" />
      {isFetching ? (
        <LoadingSkeleton type="bigcardlist" />
      ) : (digitalLiveClassListData != null &&
          digitalLiveClassListData.length) ||
        rows ? (
        <>
          {populateExamHallList()}
          <div className="attempt-heading">Your Attempted Papers</div>
          <AttemptedExamTable rows={rows} />
        </>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}

      <PopUpModal
        ref={childRef}
        header={examDetails.TestTitle}
        body={<ExamHallAttempt />}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
      />
    </>
  );
}
